import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import Moment from 'moment';
import GenericModal from '../../GenericModal'
import employeeService from '../../../services/Employee.service'
import { connect } from 'react-redux'
import {UserRoles} from '../../../constants'

const Content = styled.div`

  > div.info {

    background-color: #EDEDED;
    padding: 16px 20px 17px 20px;

    > div.award-info-area {
      background-color: #EDEDED;
      display: inline-block;
      margin-top: 3px;

      > div.award-info {
         font-family: Lato-Regular;
         font-size: 12px;
         font-weight: normal;

         color: #666666;
         line-height: 16px;
         margin: 0;
       }

       .award-name {
          font-family: Lato-Regular;
          font-size: 14px;
          color: #2B2B2B;
          line-height: 22px;
          margin-top: 3px;
          display: block;
        }

        .award-date {
          display: block;
          font-family: Lato-Regular;
          font-size: 12px;
          color: #666666;
          line-height: 16px;
        }
    }

    > div.vest-broker-area {
      float: right;
      margin-top: 3px;

      > div.vest-broker-title {
        font-family: Lato-Regular;
        font-size: 12px;
        font-weight: normal;

        color: #666666;
        line-height: 16px;
        margin: 0;
      }

      > span.vest-broker {
        font-family: Lato-Regular;
        font-size: 14px;
        color: #2B2B2B;
        line-height: 16px;
        margin-top: 12px;
        display: block;
      }
    }
  }

  > div.list {
    padding: 16px 20px 21px 20px;

    > div.vest-list {

      > div {
        font-family: Lato-Regular;
        font-size: 12px;
        font-weight: normal;

        color: #666666;
        line-height: 16px;
        margin: 0;
      }

      > div.scroll {
        overflow-y: scroll;
      }

      > div {

        // Desktop version.
        @media (min-width: 768px) {

          max-height: 264px;
        }

        .vest {
          padding: 5px 10px;

          span {
            font-family: Lato-Regular;
            font-size: 14px;
            color: #2B2B2B;
            line-height: 22px;
          }

          span:nth-child(2) {
            float: right;
          }
        }

        > div:not(:last-child) {
          border-bottom: 1px solid #DDDDDD;
        }
      }
    }

    div.total {
      background-color: #e6f7ed;
      padding: 5px 10px;
      box-shadow: 0 -1px 0 0 #00B550;

      span {
        font-family: Lato-Regular;
        font-size: 14px;
        color: #2B2B2B;
        line-height: 22px;
      }

      span:nth-child(2) {
        float: right;
      }
    }

  }
`

const Footer = styled.div`
  > button {
    height: 41px;
    width: 100%;
  }
`

export class ReviewAwardDialog extends Component {

  buttonClickHandler = (callback) => {
    this.props.onReviewDocumentAward(this.props.data.award)
  }

  render() {
    const { t, employee } = this.props;
    const { award } = this.props.data;
    const vestSchedule = employeeService.extractVestSchedule(award)

    return (
      <GenericModal
        title = {t('ReviewAwardDialog.Title',{award_type_name: award.amazon_award_name})}
        visible = {this.props.visible}
        onCloseDialog = {this.props.onCloseDialog}
        width = {380}
        className="review-award-dialog-container"
      >
        <Content className="review-award-dialog">
          <div className="info">
            <div className='award-info-area'>
              <div className='award-info'>{t('ReviewAwardDialog.AwardInfo')}</div>
              <span className='award-name'>{`${award.amazon_award_name} | ${award.amazon_award_id} `}</span>
              <span className='award-date'>{t('ReviewAwardDialog.AwardedOn', {awarded_date: Moment(award.awarded_date).format('ll')})}</span>
            </div>
          </div>
          <div className="list">
            <div className='vest-list'>
              <div role="columnheader">{t('ReviewAwardDialog.VestSchedule')}</div>
              <div className={vestSchedule && vestSchedule.length > 8 ? 'scroll' : ''}>
                {
                  vestSchedule.map((vest, index) => {
                    return <div role="row" key={`vest_${index}`} className="vest">
                            <div role="cell">
                              <span>{Moment(vest.vest_date).format('ll')}</span>
                              <span>{new Intl.NumberFormat(this.props.locale).format(vest.vest_shares)} RSUs</span>
                            </div>
                          </div>
                          })
                }
              </div>
              <div role="row" className="total">
                <div role="cell">
                  <span>{t('ReviewAwardDialog.Total')}</span>
                  <span>{new Intl.NumberFormat(this.props.locale).format(award.shares_awarded)} RSUs</span>
                </div>
              </div>
            </div>
          </div>
        </Content>
        { employeeService.hasRole(employee.roles, UserRoles.ACCEPT_AWARD) &&
          <Footer>
            <button aria-haspopup="true" className='primary-button view-documentation-and-accept-award' onClick={this.buttonClickHandler}>{t('ReviewAwardDialog.ViewDocumentation')}</button>
          </Footer>
        }

      </GenericModal>
    )
  }
}
const mapState = state => ({
  employee: state.employee
})

export default connect(mapState)(withTranslation('translations')(ReviewAwardDialog));

